import React, { forwardRef,useImperativeHandle,useRef,useEffect } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useTransactionTypes } from "../../context/TransactionTypeContext.jsx";

import { useMasterData } from "../../context/MasterDataContext.jsx";


const Comp_TransactionType = forwardRef(({
    maxTags = undefined,
    // style='',
    style={},        // container style
    tagStyle={},  // tags
    inputStyle={}, // input field



    // defaultTags = [],
    controlType = 1, // default 1 for Sale types, 2 for Purchase Types
    onTransactionTypeSelect,
    onTransactionTypeRemove,
    onTransctionTypeChangeTag,
    selectedTags = [],
    setSelectedTags = () => {},

}, ref) => {
    const placeHolder = "Select Transaction Type";
    // const masterTransactionType = useTransactionTypes(); // Assuming this returns the list of transaction types
    // const {transactionTypes:masterTransactionType,ready:transtypeReady}=useTransactionTypes();

    // const {
    //     transactionTypes:masterTransactionType,
    //     transactionTypesReady:transtypeReady
    // }= useMasterData();   
    
    const {
    transactionTypes,
    transactionTypesReady,
    reqtransactionTypes,
    reqtransactionTypesReady,
    } = useMasterData();

const masterTransactionType =
  controlType === 2 ? reqtransactionTypes : transactionTypes;

const transtypeReady =
  controlType === 2 ? reqtransactionTypesReady : transactionTypesReady;




    const tagrefTransType = useRef(null);



    //  // Apply defaultTags when they change
    //  useEffect(() => {
    //     if (defaultTags && defaultTags.length > 0) {
    //         tagrefTransType.current.setTags(defaultTags); // Explicitly set defaultTags
    //         // console.log("Default tags applied:", defaultTags);
    //     }
    // }, [defaultTags]);


        const hasInitialized = useRef(false);


    /**
     * Resolve transaction type IDs or mixed tags into full objects from masterTransactionType
     * @param {Array<number|string|object>} idsOrObjects
     * @returns {Array<object>}
     */
    const getObjectFromIds = (idsOrObjects) => {
        // console.log("controlTranstype: getting ids for returning objec",idsOrObjects)

        if (!Array.isArray(idsOrObjects) || !Array.isArray(masterTransactionType)) return [];
        return idsOrObjects
            .map(tagOrId => {
                if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'transactiontype' in tagOrId) {
                    return tagOrId;
                }
                const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
                    ? parseInt(tagOrId, 10)
                    : tagOrId;

                return masterTransactionType.find(tt => {
                    const tid = tt.id;
                    return (typeof tid === 'number' && tid === rawId) ||
                           (typeof tid === 'string' && tid === ('' + rawId));
                });
            })
            .filter(Boolean)
            .map(tt => ({ ...tt, status: 'default' }));
    };







        // useEffect(() => {
        //     if (!hasInitialized.current && defaultTags && defaultTags.length > 0 && tagrefTransType.current) {
        //         tagrefTransType.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // }, [defaultTags?.length]);




 // Apply defaultTags when ready and not initialized
    useEffect(() => {
        if (
            // !hasInitialized.current &&
            // Array.isArray(defaultTags) &&
            // defaultTags.length > 0 &&
            
            // tagrefTransType.current &&
            transtypeReady
            // Array.isArray(masterTransactionType) &&
            // masterTransactionType.length > 0
        ) {
            // console.log("converting default tags to objects of transactiontypes");
            const initialTags = getObjectFromIds(selectedTags);
            tagrefTransType.current.setTags(initialTags);
            hasInitialized.current = true;
        }
    }, [ transtypeReady, masterTransactionType]);


















// useEffect(() => {
//     if (defaultTags && defaultTags.length > 0) {
//         tagrefTransType.current.setTags(defaultTags);
//     }
//     // ✅ Run only once on mount
//     // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []); // 👈 empty dependency array


    // console.log("Transaction Types: " +masterTransactionType);

    const handleSelectTag = (tag) => {
        if (onTransactionTypeSelect) {
            // alert('in the TransactionType componenet of SelectTag event')
            onTransactionTypeSelect(tag);
        }



    };

    const handleRemoveTag = (tag) => {
        if (onTransactionTypeRemove) {
            onTransactionTypeRemove(tag);
        }



    };

    const handleChangeTag = (AllTags) => {
        // console.log("change in Transaction type component")
        if (onTransctionTypeChangeTag) {
            onTransctionTypeChangeTag(AllTags);
        }
    };

    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getTransactionTypeTags: () => tagrefTransType.current.getTags(),
        // setTransactionTypeTags: (selected) => tagrefTransType.current.setTags(selected)
        getObjectFromIds,
        getTransactionTypeTags: () => selectedTags,
        setTransactionTypeTags: (tags) => setSelectedTags(tags),

    }));
    



    return (
        <div>
            <ComponentTagSelector
                ref={tagrefTransType}
                
                // style={style}
                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field


                suggestions={masterTransactionType}
                // defaultTags={defaultTags}
                maxTags={maxTags}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}

                // if nothing is specified then unlimited, else 1 even if 10 is defined
                displayKey="transactiontype"
                allowFreeAdd={false}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag} // Pass the function correctly
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
            />
        </div>
    );
});

export default Comp_TransactionType;
